module.exports = __webpack_public_path__ + "img/zhong.d0289dc0.png";